import React, {useEffect, useRef, useState} from 'react';
import {TransformWrapper, TransformComponent, useControls} from 'react-zoom-pan-pinch';

interface ImageProps {
    modifiedCdnUrl: string;
    cdnUrl: string;
    cropMode: boolean;
    onZoomChange: (zoomPercentage: number) => void;
    imageDimension: (width: number, height: number) => void;
}

export default function ImageRenderer({modifiedCdnUrl, cdnUrl, onZoomChange, cropMode, imageDimension}: ImageProps) {
    const [isLoading, setIsLoading] = useState(true);
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const [zoomPercentage, setZoomPercentage] = useState(100);
    const Controls = () => {
        const {zoomIn, zoomOut, resetTransform} = useControls();
        const handleZoomIn = () => {
            zoomIn();
        };
        const handleZoomOut = () => {
            zoomOut();
        };
        const handleReset = () => {
            zoomOut();
        };
        useEffect(() => {
            window.addEventListener('zoomInClicked', handleZoomIn, {once: true});
            window.addEventListener('zoomOutClicked', handleZoomOut, {once: true});
            window.addEventListener('zoomResetClicked', handleReset, {once: true});
            return () => {
                window.removeEventListener('zoomInClicked', handleZoomIn);
                window.removeEventListener('zoomOutClicked', handleZoomOut);
                window.removeEventListener('zoomResetClicked', handleReset);
            };
        }, []);
        return (
            <>
                <button onClick={() => zoomIn()}></button>
                <button onClick={() => zoomOut()}></button>
                <button onClick={() => resetTransform()}></button>
            </>
        );
    };

    const handleZoomChange = (zoomScale: number) => {
        setZoomPercentage(zoomScale * 100);
        onZoomChange(zoomPercentage);
    };

    useEffect(() => {
        setIsLoading(true);

        const imageUrl = modifiedCdnUrl.length > 0 ? modifiedCdnUrl : cdnUrl;
        const img = new Image();

        img.onload = () => {
            const canvas = canvasRef.current;
            const ctx = canvas?.getContext('2d');
            imageDimension(img.width, img.height);
            if (ctx && canvas) {
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                setIsLoading(false);
            }
        };

        img.src = imageUrl;
    }, [modifiedCdnUrl, cdnUrl]);

    return (
        <>
            <div className='relative flex items-center justify-center bg-[#EAECF0]'>
                {!cropMode ? (
                    <TransformWrapper
                        initialScale={1}
                        minScale={0.5}
                        maxScale={7}
                        onTransformed={(e) => handleZoomChange(e.state.scale)}>
                        <Controls />
                        <TransformComponent>
                            <canvas
                                ref={canvasRef}
                                className='max-h-[73vh] w-full'
                                style={{display: isLoading ? 'none' : 'block'}}
                            />
                        </TransformComponent>
                    </TransformWrapper>
                ) : (
                    <canvas
                        ref={canvasRef}
                        className='max-h-[73vh] w-full'
                        style={{display: isLoading ? 'none' : 'block'}}
                    />
                )}
            </div>
        </>
    );
}
